import angular from 'angular';
import moment from 'moment';

export class PersonaAfastamentos {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entities: any = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: any = {
        to_load: 3,
        busy: false,
        finished: false,
    };
    public loading_deferred: any = null;
    public filter: any = '';
    public loading_deferred_filter: any;
    public entitiesFirstLoad: any = [];

    constructor(
        public $http: any,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService,
        public $q: any
    ) { }

    reload() {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search (filter: any): Array<any> | angular.IHttpPromise<any> {

        let filters = {};
        let search = '';

        if (typeof filter !== 'undefined' && filter !== null) {

            search = filter.search ? filter.search : '';

            Object.keys(this.filters).forEach((k) => { delete this.filters[k]; });
            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        } else if (filter === null) {
            if (this.loading_deferred_filter) {
                this.loading_deferred_filter.resolve();
            }

            return this._load(this.constructors, {}, '');
        }

        if (filter.lookup) {
            if (this.loading_deferred_filter) {
                this.loading_deferred_filter.resolve();
            }

            return this._load(this.constructors, {}, search);
        } else {
            this.filter = search;
            this.filters = filters;

            return this.reload();
        }
    }

    _load (constructors: any, offset: any, filter: any) {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve, reject) => {
            constructors.order = {
                'data': 'DESC'
            };
            this.$http({
                    method: 'GET',
                    url: this.nsjRouting.generate('persona_afastamentos_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                    timeout: this.loading_deferred.promise
                })

                .then((response) => {

                    let dadosApi = angular.copy(response.data);

                    if (!this.entitiesFirstLoad.length && dadosApi.length) {
                        this.entitiesFirstLoad = angular.copy(response.data);
                    }

                    if (constructors._tipoHistorico) {
                        dadosApi = this.getAfastamentoMaisRecente(constructors._tipoHistorico, dadosApi);
                    }

                    if (constructors._apenasComDataRetorno) {
                        dadosApi = dadosApi.filter(afastamento => !afastamento.semdataretorno);
                    }

                    dadosApi.forEach(afastamentotrabalhador => {
                        let datafim = angular.copy(afastamentotrabalhador.data);
                        afastamentotrabalhador['data'] = moment(afastamentotrabalhador.data).format('DD/MM/YYYY');
                        afastamentotrabalhador['datafim'] = moment(datafim).add(afastamentotrabalhador.dias, 'days').format('DD/MM/YYYY');
                        afastamentotrabalhador['descricao'] = afastamentotrabalhador.tipohistorico.tipohistorico + ' - ' + afastamentotrabalhador.descricao;
                        if (typeof afastamentotrabalhador.afastamentotrabalhadorpai === 'string') {
                            const afastamentoPai = this.entitiesFirstLoad.find(item => item.afastamentotrabalhador === afastamentotrabalhador.afastamentotrabalhadorpai);
                            if (afastamentoPai) {
                                afastamentotrabalhador['afastamentotrabalhadorpai'] = afastamentoPai;
                            }
                        }
                    });

                    resolve(dadosApi);
                })
                .catch((response) => {
                    reject(response);
                });

        });

    }

    /**
     * Recebe o código do motivo de afastamento para filtrar a lista e manter apenas os afastamentos de origem compatíveis com o motivo.
     * Uma vez que a lista é filtrada, retorna apenas o afastamento de origem mais recente, baseado em sua data
     * @param filtroAfastamento O código do motivo de afastamento
     * @param listaAfastamentos A lista de afastamentos a ser processada
     */
    getAfastamentoMaisRecente(filtroAfastamento: string, listaAfastamentos: Array<any>) {
        const motivos = {
            ACIDENTE_TRABALHO: '001',
            ACIDENTE_TRABALHO_PRORROGADO: '002',
            DOENCA: '003',
            DOENCA_PRORROGADO: '004'
        };
        let afastamentosTipoCorreto: any = [];

        if (filtroAfastamento === motivos.ACIDENTE_TRABALHO_PRORROGADO) {
            afastamentosTipoCorreto = listaAfastamentos.filter((afastamento) => {
                return afastamento.tipohistorico.tipohistorico === motivos.ACIDENTE_TRABALHO;
            });
        } else if (filtroAfastamento === motivos.DOENCA_PRORROGADO) {
            afastamentosTipoCorreto = listaAfastamentos.filter((afastamento) => {
                return afastamento.tipohistorico.tipohistorico === motivos.DOENCA;
            });
        }

        if (afastamentosTipoCorreto.length === 0) {
            return [];
        }

        return afastamentosTipoCorreto.slice(0, 5);

    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data) => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                    }
                    this.loadParams.finished = true;
                    this.$rootScope.$broadcast('persona_afastamentos_list_finished', this.entities);
                    this.loaded = true;

                    this.loadParams.to_load--;
                })
                .catch((error) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                });
        }

        return this.entities;
    }

    loadMore() {
        this.loadParams.to_load = 3;
        this.load();
    }

    find(identifier: any) {
        for (let i in this.entities) {
            if (this.entities[i]['afastamentotrabalhador'] === identifier) {
                return this.entities[i];
            }
        }
        return null;
    }

    _save (entity: any, autosave: any) {
        let method, url;
        if (entity['afastamentotrabalhador']) {
            method = 'PUT';
            url = this.nsjRouting.generate('persona_afastamentos_put', { trabalhador: entity.trabalhador, 'id': entity['afastamentotrabalhador'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('persona_afastamentos_create', angular.extend(this.constructors), true);
        }
        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }
        let data = angular.copy(entity);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
                method: method,
                url: url,
                data: data,
                timeout: this.loading_deferred.promise
            })
            .finally((response) => {
                if (!autosave) {
                    entity['$$__submitting'] = false;
                }
            });
    }

    save(entity: any, autosave: any) {

        this
            ._save(entity, autosave)
            .then((response) => {
                if (response.data.afastamentotrabalhador) {
                    entity['afastamentotrabalhador'] = response.data.afastamentotrabalhador;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('persona_afastamentos_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response) => {
                this.$rootScope.$broadcast('persona_afastamentos_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    get(trabalhador: any, identifier: any) {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve, reject) => {
            this.$http
                .get(this.nsjRouting.generate('persona_afastamentos_get', { 'trabalhador': trabalhador, 'id': identifier }, true), { timeout: this.loading_deferred.promise })
                .then((response) => {
                    this.$rootScope.$broadcast('persona_afastamentos_loaded', response.data);
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    }

}

angular.module('main').service('PersonaAfastamentos', PersonaAfastamentos);
